import { track } from "~/lib/segmentAnalytics";

import {
  ContentAttribute,
  ContentItem,
} from "~/components/shared/StepsEditorSidebar/Guide/useGuide";

export type TrackingContext = {
  organizationUuid: string;
};

export function trackItemSelected(item: ContentItem, trackingContext: TrackingContext) {
  track("Step Editor Guide Content Item Clicked", {
    name: item.name,
    organization_uuid: trackingContext.organizationUuid,
  });
}

// Filter which matches either in the ContentAttribute's name, or the first line of the `textContent` value.
export function attributeDoesMatchFilter(
  { name, textContent }: ContentAttribute,
  filterText: string,
) {
  // If the name matches, we return immediately to avoid more complicated tests
  if (name.indexOf(filterText) !== -1) {
    return true;
  }

  // First, quickly find the first line ending, or just the
  // length of the whole string if there isn't one
  let firstLineOrEndIndex = textContent.indexOf("\n");
  if (firstLineOrEndIndex === -1) {
    firstLineOrEndIndex = textContent.length;
  }

  // Then, let's grab that chunk of the string, and strip out links,
  // and find the first index of a match in the textContent
  return (
    textContent
      .slice(0, firstLineOrEndIndex)
      .replace(/!?\[([^\]]+)\]\([^)]+\)/g, "$1")
      .indexOf(filterText) !== -1
  );
}
